import { FC, useMemo } from "react";
import { useAppSelector } from "../store";

import { VviinnForms } from "../forms";

import { useParams } from "react-router";
import { pageError } from "./error";

type PlanFormType = { formType: "new" | "details" };

export const Plan: FC<PlanFormType> = ({ formType }) => {
  const { planId } = useParams();
  const company = useAppSelector((state) => state.company?.company);
  const planActions = company?.plans?.actions;
  const planCreate = planActions?.create;
  const relevantPlan = useMemo(() => {
    return planId
      ? company?.plans?.items?.find(({ action }) =>
          action?.navigateUrl?.endsWith(planId),
        )
      : undefined;
  }, [planId]);

  if (formType === "details") {
    return relevantPlan ? (
      <VviinnForms
        formType="plan"
        id={planId}
        actionId={relevantPlan.action.id}
        requestType={relevantPlan.action.requestType}
      />
    ) : (
      pageError("404")
    );
  } else
    return (
      <VviinnForms
        formType="plan"
        actionId={planCreate?.id}
        requestType={planCreate?.requestType}
      />
    );
};
